<template>
  <div class="login-container">
    <div class="login-form">
      <div class="login-header">
        <div class="logo-text">小胡童</div>
        <h2>小胡童系统登录</h2>
        <p class="subtitle">欢迎回来，请登录您的账户</p>
      </div>
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="0px" class="demo-ruleForm">
        <el-form-item prop="mobile">
          <el-input 
            v-model="ruleForm.mobile" 
            placeholder="请输入账号" 
            prefix-icon="el-icon-user" 
            clearable 
            maxlength="20"
            @blur="validateUsername">
            <template slot="prepend">账号</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input 
            v-model="ruleForm.password" 
            type="password" 
            placeholder="请输入密码" 
            prefix-icon="el-icon-lock" 
            clearable 
            maxlength="20" 
            show-password
            @blur="validatePassword">
            <template slot="prepend">密码</template>
          </el-input>
        </el-form-item>


        <el-form-item prop="captcha">
          <el-row :gutter="10">
            <el-col :span="16">
              <el-input 
                v-model="ruleForm.captcha" 
                placeholder="请输入验证码" 
                prefix-icon="el-icon-key" 
                maxlength="4"
                @keyup.enter.native="submitForm">
                <template slot="prepend">验证码</template>
              </el-input>
            </el-col>
            <el-col :span="8">
              <img :src="captchaUrl" @click="refreshCaptcha" class="captcha-img" alt="点击刷新验证码" title="点击刷新验证码" />
            </el-col>
          </el-row>
        </el-form-item>


        <el-form-item>
          <el-row type="flex" justify="space-between" align="middle">
            <el-checkbox v-model="rememberpwd" class="remember-text">记住密码</el-checkbox>
            <el-button type="text" @click="forgotPassword" class="forgot-link">忘记密码？</el-button>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            @click="submitForm" 
            :loading="logining" 
            class="login-btn" 
            :disabled="!canSubmit"
            size="medium">
            {{ logining ? '登录中...' : '登录' }}
          </el-button>
        </el-form-item>
      </el-form>
      <div class="register-link">
        <span class="register-text">还没有账号？</span>
        <el-button type="text" @click="goToRegister" class="register-btn">立即注册</el-button>
      </div>
      <div class="login-footer">
        <p class="version">版本号：v1.0.0</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { login,captcha,captcha2 } from '../api/shop'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      logining: false,
      rememberpwd: false,
      showCaptcha: true,
      ruleForm: {
        mobile: '',
        password: '',
        captcha: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '验证码长度为4位', trigger: 'blur' }
        ]
      },
      captchaUrl: ''
    }
  },
  computed: {
    canSubmit() {
      return this.ruleForm.mobile && 
             this.ruleForm.password &&
             (!this.showCaptcha || this.ruleForm.captcha)
    }
  },

  created() {
    this.getuserpwd()
    this.refreshCaptcha()
  },

  methods: {
    getuserpwd() {
      const savedUser = getCookie('user')
      const savedPwd = getCookie('pwd')
      if (savedUser && savedPwd) {
        this.ruleForm.mobile = savedUser
        this.ruleForm.password = savedPwd
        this.rememberpwd = true
      }
    },

    refreshCaptcha2(){
      this.refreshCaptcha()
    },

    validateUsername() {
      this.$refs.ruleForm.validateField('mobile')
    },

    validatePassword() {
      this.$refs.ruleForm.validateField('password')
    },

    refreshCaptcha() {
      // 生成带时间戳的验证码URL，防止浏览器缓存
      const timestamp = new Date().getTime()
      this.captchaUrl = this.$captcha + `/api/saas/xht/shop/creatCaptcha?t=${timestamp}`
      
      // 清空验证码输入框
      if (this.$refs.ruleForm) {
        this.ruleForm.captcha = ''
      }
    },

    forgotPassword() {
      this.$router.push('/update')
    },

    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.logining = true
          login(this.ruleForm).then(res => {
            if (res.code === 1) {
              console.log('登录成功返回数据：', res);

              // 处理记住密码
              if (this.rememberpwd) {
                setCookie('user', this.ruleForm.mobile, 7)
                setCookie('pwd', this.ruleForm.password, 7)
              } else {
                delCookie('user')
                delCookie('pwd')
              }

              // 存储用户信息
              localStorage.setItem('logintoken', res.data.token)

              // 存储用户信息到localStorage和Vuex
              const userInfo = res.data || { role: 'admin' }; // 默认admin角色
              localStorage.setItem('userInfo', JSON.stringify(userInfo))
              
              // 存储到Vuex
              this.$store.commit('login', JSON.stringify(userInfo))

              // 跳转首页或重定向页面
              this.logining = false
              const redirect = this.$route.query.redirect || '/shop/Index'
              this.$router.replace(redirect)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              this.refreshCaptcha() // 登录失败刷新验证码
              return false
            }
          }).catch(err => {
            console.error('登录请求失败', err)
            this.$message.error('登录失败，请重试')
            this.logining = false
            this.refreshCaptcha()
          })
        } else {
          this.$message.error('请完善表单信息！')
          return false
        }
      })
    },

    goToRegister() {
      this.$router.push('/register')
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.login-form {
  background: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  position: relative;
  overflow: hidden;
}

.login-form::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea, #764ba2);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.logo-text {
  width: 60px;
  height: 60px;
  margin: 0 auto 10px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.login-header h2 {
  color: #333;
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 1px;
}

.login-header .subtitle {
  color: #666;
  font-size: 14px;
  margin-top: 8px;
  opacity: 0.8;
}

.demo-ruleForm .el-form-item {
  margin-bottom: 24px;
}

.demo-ruleForm .el-input-group__prepend {
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  color: #606266;
  font-size: 14px;
}

.captcha-img {
  width: 100%;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
}

.captcha-img:hover {
  opacity: 0.8;
  transform: scale(1.02);
}

.remember-text {
  color: #666;
  font-size: 14px;
}

.forgot-link {
  color: #409EFF;
  padding: 0;
  font-size: 14px;
  transition: all 0.3s ease;
}

.forgot-link:hover {
  color: #66b1ff;
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 6px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
}

.login-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.register-link {
  text-align: center;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.register-text {
  color: #666;
  font-size: 14px;
}

.register-btn {
  color: #409EFF;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.register-btn:hover {
  color: #66b1ff;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
}

.version {
  color: #999;
  font-size: 12px;
  margin: 0;
  opacity: 0.7;
}

/* 响应式设计 */
@media screen and (max-width: 480px) {
  .login-container {
    padding: 10px;
  }
  
  .login-form {
    padding: 30px 20px;
    margin: 10px;
  }
  
  .login-header h2 {
    font-size: 24px;
  }
  
  .login-btn {
    height: 42px;
    font-size: 15px;
  }
}

/* 动画效果 */
.login-form {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>


// WEBPACK FOOTER //
// src/views/login.vue